import { useEffect, useState } from 'react';
import { heroService } from '../Model/Services/heroService.js';

export const DEFAULT_STARTPAGE_CONTENT = {
  tagline: '',
  headline: 'En redovisningspartner som tar dig vidare.',
  subheadline: 'Personlig kontakt. Smarta processer. Resultat du märker.',
  buttonText: 'Få hjälp direkt',
  buttonHref: '#kontakt',
  backgroundImage: '/Images/works.jpg',
};

const LOCAL_STORAGE_KEY = 'startpageContentCache';

const loadCachedContent = () => {
  if (typeof window === 'undefined' || !window.localStorage) return null;
  try {
    const raw = window.localStorage.getItem(LOCAL_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
};

const saveCachedContent = (content) => {
  if (typeof window === 'undefined' || !window.localStorage) return;
  try {
    window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(content));
  } catch (_) {
    // ignore storage errors
  }
};

export const useStartPageContent = () => {
  const [content, setContent] = useState(() => loadCachedContent());
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [saving, setSaving] = useState(false);

  const fetchContent = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await heroService.get();
      setContent(data);
      if (data) saveCachedContent(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContent();
  }, []);

  const saveContent = async (data) => {
    setSaving(true);
    setError(null);
    try {
      const saved = await heroService.upsert(data);
      setContent(saved);
      return saved;
    } catch (err) {
      setError(err.message);
      throw err;
    } finally {
      setSaving(false);
    }
  };

  return {
    content,
    loading,
    error,
    saving,
    refresh: fetchContent,
    saveContent,
  };
};
